module.exports = __webpack_public_path__ + "static/media/  (147).08a50365.jpg";